export default "__VITE_ASSET__NC8ETKbE__"